import { type BufferAttribute, FloatType } from '@seddi/three';
import { assert } from '../../core/assert';

export const transformUvsDirectXToOpenGL = (self: BufferAttribute) => {
  assert(self.isBufferAttribute, 'Buffer attribute');
  assert(self.gpuType === FloatType, 'Buffer attribute GPU type');

  // Transform V coordinates so that 0,0 is at the bottom left corner
  const array = self.array;

  for (let i = 0, n = array.length, o = self.itemSize; i < n; i += o) {
    array[i + 1] = 1.0 - array[i + 1];
  }
};
